import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../../index";
import { Pagination as BootstrapPagination } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

const Pagination = observer(() => {
  const { product } = useContext(Context);
  const pageCount = product.pageCount;         // от бэка, без -1
  const currentPage = product.page;            // 0-based

  const isMobile = useMediaQuery({ maxWidth: 600 });

  if (pageCount <= 1) return null;

  const handleClick = (page) => {
    if (page !== currentPage && page >= 0 && page < pageCount) {
      product.setPage(page);
      product.setReload(product.reload + 1);
    }
  };

  const getPageItem = (page) => (
    <BootstrapPagination.Item
      key={page}
      active={page === currentPage}
      onClick={() => handleClick(page)}
    >
      {page + 1}
    </BootstrapPagination.Item>
  );

  const renderPages = () => {
    const pages = [];

    if (isMobile) {
      // Мобильная версия: только текущая, предыдущая и следующая
      if (currentPage > 0) pages.push(getPageItem(currentPage - 1));
      pages.push(getPageItem(currentPage));
      if (currentPage < pageCount - 1) pages.push(getPageItem(currentPage + 1));
    } else {
      if (pageCount <= 7) {
        for (let i = 0; i < pageCount; i++) {
          pages.push(getPageItem(i));
        }
      } else {
        pages.push(getPageItem(0)); // первая страница

        if (currentPage > 2) {
          pages.push(<BootstrapPagination.Ellipsis key="start-ellipsis" disabled />);
        }

        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          if (i > 0 && i < pageCount - 1) {
            pages.push(getPageItem(i));
          }
        }

        if (currentPage < pageCount - 3) {
          pages.push(<BootstrapPagination.Ellipsis key="end-ellipsis" disabled />);
        }

        pages.push(getPageItem(pageCount - 1)); // последняя страница
      }
    }

    return pages;
  };

  return (
    <div className="d-flex justify-content-center mt-4">
      <BootstrapPagination size={isMobile ? "sm" : "md"}>
        <BootstrapPagination.First
          onClick={() => handleClick(0)}
          disabled={currentPage === 0}
        />
        <BootstrapPagination.Prev
          onClick={() => handleClick(currentPage - 1)}
          disabled={currentPage === 0}
        />
        {renderPages()}
        <BootstrapPagination.Next
          onClick={() => handleClick(currentPage + 1)}
          disabled={currentPage === pageCount - 1}
        />
        <BootstrapPagination.Last
          onClick={() => handleClick(pageCount - 1)}
          disabled={currentPage === pageCount - 1}
        />
      </BootstrapPagination>
    </div>
  );
});

export default Pagination;
